import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const convertPoints = (value, fixed) => {
  const number = parseFloat(value)

  return number
    .toFixed(fixed)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

const DisplayPoints = ({
  hasDiscount,
  regularPrice,
  price,
  currency,
  hasPointCash
}) => (
  <Fragment>
    {(hasDiscount) && (
      <div className='card-price-from col-12 txt-subtitle txt-font-body txt-lowecase color-ui-2 txt-left'>
        {`de ${regularPrice} ${currency && currency.name}`}
      </div>
    )}
    <div className='card-price-points col-12 txt-title txt-font-body txt-left color-ui-1 nowrap'>
      <span className='price-value'>
        {`${(hasDiscount) ? 'por' : ''} ${convertPoints(price, currency.decimalPlaces)} ${currency.name}`}
      </span>
    </div>
    {hasPointCash && (
      <div className='card-price-complete-with col-12 txt-body-sm txt-font-body txt-left txt-bold color-success'>
        <div className='row'>
          {/* <div className='col-12 pt-half'>Ou utilize pontos + dinheiro</div> */}
        </div>
      </div>
    )}
  </Fragment>
)

DisplayPoints.propTypes = {
  hasDiscount: PropTypes.bool,
  regularPrice: PropTypes.number,
  price: PropTypes.number.isRequired,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  hasPointCash: PropTypes.bool
}

export default DisplayPoints



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/DisplayPoints.js